import { useTranslation } from "react-i18next";
import TextInput from "../../inputs/textInput";

const Step3Form = ({ formik }) => {
  const { t } = useTranslation();
  console.log(formik.errors, "errors");

  return (
    <div className="space-y-4">
      <div>
        <h1>{t("uHavePriorExperience")}</h1>
        <div className="flex items-center gap-2">
          <input
            onChange={formik.handleChange}
            type="radio"
            id="yes"
            name="experience"
            value="yes"
            checked={formik.values.experience === "yes" ? true : false}
          />
          <label htmlFor="yes">{t("yes")}</label>
          <input
            onChange={formik.handleChange}
            type="radio"
            id="no"
            name="experience"
            value="no"
            checked={formik.values.experience === "no" ? true : false}
          />
          <label htmlFor="no">{t("no")}</label>
        </div>
        {formik.values.experience === "yes" && (
          <div className="flex flex-col gap-2 my-2">
            <h2>{t("typeOfShippingProvided")}</h2>
            <label htmlFor="airShipping" className="flex items-center gap-2">
              <input
                type="checkbox"
                id="airShipping"
                value={"airShipping"}
                name="shippingType"
                onChange={formik.handleChange}
                checked={formik.values.shippingType.includes("airShipping")}
              />
              {t("airShipping")}
            </label>
            <label htmlFor="seaShipping" className="flex items-center gap-2">
              <input
                type="checkbox"
                id="seaShipping"
                value={"seaShipping"}
                name="shippingType"
                onChange={formik.handleChange}
                checked={formik.values.shippingType.includes("seaShipping")}
              />
              {t("seaShipping")}
            </label>
            <label htmlFor="landShipping" className="flex items-center gap-2">
              <input
                type="checkbox"
                id="landShipping"
                value={"landShipping"}
                name="shippingType"
                onChange={formik.handleChange}
                checked={formik.values.shippingType.includes("landShipping")}
              />
              {t("landShipping")}
            </label>
            <label htmlFor="customsClearance" className="flex items-center gap-2">
              <input
                type="checkbox"
                id="customsClearance"
                value={"customsClearance"}
                name="shippingType"
                onChange={formik.handleChange}
                checked={formik.values.shippingType.includes("customsClearance")}
              />
              {t("customClearance")}
            </label>
            <label htmlFor="wareHouseAndStorage" className="flex items-center gap-2">
              <input
                type="checkbox"
                id="wareHouseAndStorage"
                value={"wareHouseAndStorage"}
                name="shippingType"
                onChange={formik.handleChange}
                checked={formik.values.shippingType.includes("wareHouseAndStorage")}
              />
              {t("wareHouseAndStorage")}
            </label>
            <label htmlFor="steamersAgent" className="flex items-center gap-2">
              <input
                type="checkbox"
                id="steamersAgent"
                value={"steamersAgent"}
                name="shippingType"
                onChange={formik.handleChange}
                checked={formik.values.shippingType.includes("steamersAgent")}
              />
              {t("steamersAgent")}
            </label>
            <label htmlFor="other" className="flex items-center gap-2">
              <input
                type="checkbox"
                id="other"
                value={"other"}
                name="shippingType"
                onChange={formik.handleChange}
                checked={formik.values.shippingType.includes("other")}
              />
              {t("other")}
              <input
                type="text"
                id="otherText"
                name="otherText"
                className="p-1 ml-2 border rounded"
                onChange={formik.handleChange}
                value={formik.values.otherText}
              />
              {formik.touched.otherText && formik.errors.otherText && (
                <span className="text-[12px] text-mainRed ">
                  {formik.errors.otherText}
                </span>
              )}
            </label>
            {formik.errors.shippingType && (
              <span className="text-[12px] text-mainRed ">
                {t("atLeastOnRequired")}
              </span>
            )}
            <TextInput
              formik={formik}
              placeholder={t("countriesYourCompanyCovers")}
              label={t("countriesYourCompanyCovers")}
              name={"countriesYourCompanyCovers"}
            />
            <TextInput
              formik={formik}
              placeholder={t("yearsOfExperienceInTheField")}
              label={t("yearsOfExperienceInTheField")}
              name={"yearsOfExperienceInTheField"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Step3Form;
